import {createSlice} from '@reduxjs/toolkit';
import {STEPS} from './utils/constants';
import {getContactCompanyList} from '../PortalsBlock/portalSlice';

const initialState = {
  currentStep: STEPS.SELECT_ORGANIZATION,
  isShowPopup: false,
};

const BusinessDashboardSlice = createSlice({
  name: 'BusinessDashboardSlice',
  initialState,
  reducers: {
    reset: () => initialState,

    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },

    saveToHistory: (state, action) => {
      return state;
    },

    setIsShowPopup: (state, action) => {
      state.isShowPopup = action.payload;
    },
  },
});

export const {reset, setCurrentStep, saveToHistory, setIsShowPopup} = BusinessDashboardSlice.actions;
export default BusinessDashboardSlice.reducer;
